import styled from "styled-components";

export const LoginBodyModal = styled.div`
  text-align: center;
  padding-top: 24px;
  padding-bottom: 34px;
`;
